<template>

  
   <div v-if="hide_menu" class="absolute top-[15%] z-[60] bg-blues p-2 lg:hidden rounded-r-xl cursor-pointer h-[40px]" @click="toggleMenu">
    <!-- <div class="pl-2">
    <div class="bg-gray-500 w-8 mt-1.5 h-1 rounded-lg"></div>
    <div class="bg-gray-500 w-8 mt-1.5 h-1 rounded-lg"></div>
    <div class="bg-gray-500 w-8 mt-1.5 h-1 rounded-lg"></div>
    </div> -->
     <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20"
      height="20"
      viewBox="0 0 50 50"
      fill="#fff"
    >
      <path
        d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
      ></path>
    </svg>
  </div>

  <div
    class="lg:flex fixed w-[95%] bg-white lg:w-[35%] lg:left-0 xl:w-[30%] 2xl:w-[25%] lg:relative z-30 mt-10 lg:m-10  rounded-3xl heightfix overflow-y-auto" :class="{'hidden': !isMobile}"
    style="box-shadow: 0px 2px 30px 0px #01b0f926"
  >
  <div
      @click="toggleSidebar"
      class="absolute top-2 right-[2px] z-30 block lg:hidden bg-gray-200 rounded-full p-1 cursor-pointer"
    >
      <!-- <span class="text-2xl">⬅️</span> -->
      <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
    </div>
    <div class="flex flex-col gap-5 relative w-full overflow-y-auto  p-10">
    

      <!-- new dasboard -->
      <router-link
        :to="{ name: 'HodDashboards' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': isDashboardActive,'hover:bg-gray-100': $route.name != 'HodDashboards' }"
      >
        <img
          src="@/assets/newd/icons/Grid.png"
          v-if="isDashboardActive"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Grid-1.png"
          v-if="!isDashboardActive"
          alt=""
        />
        <p
          class="font-bold text-sm"
          :class="{
            'text-white': isDashboardActive,
            'text-[#333333]': !isDashboardActive,
          }"
        >
          Dashboards
        </p>
      </router-link>


      <router-link
        :to="{ name: 'HodCoursess' }"
        class="flex items-center gap-5 p-4 rounded-3xl hidden"
        :class="{ 'bg-[#0085DB]': $route.name == 'HodCoursess' ,'hover:bg-gray-100': $route.name != 'HodCoursess' }"
      >
        <img
          src="@/assets/newd/icons/mdi-light_forum-1.png"
          v-if="$route.name == 'HodCoursess'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/mdi-light_forum.png"
          v-if="$route.name != 'HodCoursess'"
          alt=""
        />

        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'HodCoursess',
            'text-[#333333]': $route.name != 'HodCoursess',
          }"
        >
        Courses
        </p>
      </router-link>

      <router-link
        :to="{ name: 'HodProject' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'HodProject' ,'hover:bg-gray-100': $route.name != 'HodProject' }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'HodProject'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'HodProject'"
          alt=""
        />
        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'HodProject',
            'text-[#333333]': $route.name != 'HodProject',
          }"
        >
        Blogs
        </p>
      </router-link>

      <router-link
        :to="{ name: 'HodEvents' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'HodEvents' ,'hover:bg-gray-100': $route.name != 'HodEvents' }"
      >
        <img
          src="@/assets/newd/icons/Calendar2Week-1.png"
          v-if="$route.name == 'HodEvents'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Calendar2Week.png"
          v-if="$route.name != 'HodEvents'"
          alt=""
        />

        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'HodEvents',
            'text-[#333333]': $route.name != 'HodEvents',
          }"
        >
          Events
        </p>
      </router-link>

    
     
      
    </div>
  </div>
</template>

<script>
export default {

  computed: {
    isDashboardActive(){
      return this.$route.name == 'HodDashboards' ||  this.$route.name == 'HodStaffDetails' || this.$route.name == 'HodStudentDetail' || this.$route.name == 'HodSemesterDetails' || this.$route.name == 'HodBatchDetails' || this.$route.name == 'HodProgramsDetails'
    }
  },

  data(){
    return {
      isMobile: false,
       hide_menu: true,
    }
  },
   methods:{
     toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },
     toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile; // Hide button when menu is open
    },
  }
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}</style>
